import { defineComponent as _defineComponent } from 'vue'
import CategoryFacetCard from './CategoryFacetCard.vue';
import CategoryLinkCard from './CategoryLinkCard.vue';
import { CatalogState } from 'JS/catalog/store/store';
import { computed, ComputedRef, nextTick, onMounted, ref, watch } from 'vue';
import { ISelectedFacetValue } from 'JS/types/Search';
import { useBreakpoints } from 'JS/composables/breakpoint';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';
import { useListSlider } from 'JS/composables/list-slider';
import { useViewportWidth } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCarouselApp',
  setup(__props) {

const store = useLegacyVuexStore<CatalogState>();
const { isDesktop } = useBreakpoints();
const viewportWidth = useViewportWidth();

const sidebarCategories = computed(() => store.state.categories);

const subcatFacet = computed(() => store.state.facets.find(f => f.field === 'subcat_id'));
const subcatFacetValues = computed(() => {
	const facet = store.state.facets.find(f => f.field === "subcat_id");
	if (facet != null && facet.facetType !== 'nestedcheckbox') {
		return facet.values;
	}
	return [];
});
const selectedFacets: ComputedRef<ISelectedFacetValue[]> = computed(() => store.getters.selectedFacets);
const categoryImages = computed(() => store.state.searchResult.categoryImages ?? {});

const showCarousel = computed(() => {
	return store.getters.showProducts && // on a product lists page
		!store.state.isLoadingSearchResult && // not loading
		selectedFacets.value?.length === 0 && // no facets selected
		// always show on smaller screens / minimum of 6 cards on desktop
		(!isDesktop.value || (subcatFacetValues.value.length >= 6 || sidebarCategories.value.length >= 6));
});
const showCarouselButtons = computed(() => numSlides.value > 1);
const queryString = computed(() => store.getters.queryString);

const numSlides = ref(0);
const currentSlide = ref(0);

const skipBefore = ref<HTMLElement | null>(null);
const skipAfter = ref<HTMLElement | null>(null);

const { slider, viewport, previous, next } = useListSlider(() => {
	currentSlide.value = slider?.value.getCurrentSlide() ?? 0;
});

watch(() => [viewportWidth.value, subcatFacetValues.value], () => {
	setupCarousel();
});

onMounted(() => {
	setupCarousel();
});

function setupCarousel() {
	// In order to get accurate values we need to wait until next tick
	nextTick(() => {
		slider.value?.reset();
		numSlides.value = slider.value?.getNumSlides();
		currentSlide.value = 0;
	});
}

function skipToAfter() {
	if (skipAfter.value) {
		skipAfter.value.focus();
	}
}

function skipToBefore() {
	if (skipBefore.value) {
		skipBefore.value.focus();
	}
}

return { __sfc: true,store, isDesktop, viewportWidth, sidebarCategories, subcatFacet, subcatFacetValues, selectedFacets, categoryImages, showCarousel, showCarouselButtons, queryString, numSlides, currentSlide, skipBefore, skipAfter, slider, viewport, previous, next, setupCarousel, skipToAfter, skipToBefore, CategoryFacetCard, CategoryLinkCard }
}

})